import { SUPPORTED_LOCALES } from "@/libraries/locale-codes";
import { z } from "zod";
import { AuthRegisterCredentialsBaseSchema } from "./auth";

export const BodyUpdateMemberSchema =
	AuthRegisterCredentialsBaseSchema.partial().merge(
		z.object({
			id: z.number().int({ message: "Invalid member ID" }),
			status: z.string().optional(),
			locale: z.enum(SUPPORTED_LOCALES).optional(),
		}),
	);
export type BodyUpdateMemberSchema = z.infer<typeof BodyUpdateMemberSchema>;

export const ParamsGetMembersSchema = z.object({
	search: z.string().optional(),
	page: z.number().optional(),
	limit: z.number().optional(),
	directory: z.boolean().optional(),
	phone_numbers: z.array(z.string()).optional(),
});

export type ParamsGetMembersSchema = z.infer<typeof ParamsGetMembersSchema>;

export const ParamsGetMpisMembersSchema = z.object({
	page: z.number().optional(),
	limit: z.number().optional(),
});
export type ParamsGetMpisMembersSchema = z.infer<
	typeof ParamsGetMpisMembersSchema
>;

export const PeoplePageSearchSchema = z.object({
	q: z.string().optional(),
});

export type PeoplePageSearchSchema = z.infer<typeof PeoplePageSearchSchema>;

export const GetMemberSyncChatParamsSchema = z.object({
	last_requested_at: z.number().int(),
	page: z.number().optional(),
	limit: z.number().optional(),
});

export type GetMemberSyncChatParamsSchema = z.infer<
	typeof GetMemberSyncChatParamsSchema
>;

export const PostMemberUpdateVersionBodySchema = z.object({
	app_version: z.string(),
	platform: z.enum(["web"]),
});

export type PostMemberUpdateVersionBodySchema = z.infer<
	typeof PostMemberUpdateVersionBodySchema
>;

export const GetMyAlertsParamsSchema = z.object({
	scope: z
		.enum(["my_outstanding", "awaiting_response", "responded"])
		.optional(),
	search: z.string().optional(),
	page: z.number().int().optional(),
	limit: z.number().int().optional(),
});

export type GetMyAlertsParamsSchema = z.infer<typeof GetMyAlertsParamsSchema>;
